module.exports = __webpack_public_path__ + "img/tiktok.842697a5.png";